import React from 'react';

import { Airport } from 'models/airport';
import { City } from 'models/city';

import Result from './styles';

export interface Props {
  data: Airport | City;
  isCity?: boolean;
  onClick: (data: Airport | City, isCity?: boolean) => void;
}

const ResultItem = ({ data, isCity, onClick }: Props) => (
  <Result onClick={() => onClick(data, isCity)}>
    <Result.info>
      <Result.Title>
        {isCity ? <Result.city /> : <Result.icon />}
        {`${data.related_city}, ${data.country}`}
      </Result.Title>
      {!isCity && <Result.SubTitle>{data.description}</Result.SubTitle>}
    </Result.info>
    {!isCity && <Result.Code>{`${data.code}`}</Result.Code>}
  </Result>
);

export default ResultItem;
